import { useLanguage } from "@/i18n/LanguageContext";

export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { t, locale, setLocale } = useLanguage();
  return (
    <div className={`dn-lang-switch ${className}`.trim()} role="group" aria-label={t.nav.language}>
      <button
        type="button"
        className={`dn-lang-btn${locale === "en" ? " is-active" : ""}`}
        aria-pressed={locale === "en"}
        onClick={() => setLocale("en")}
      >
        {t.nav.langEn}
      </button>
      <button
        type="button"
        className={`dn-lang-btn${locale === "ar" ? " is-active" : ""}`}
        aria-pressed={locale === "ar"}
        onClick={() => setLocale("ar")}
      >
        {t.nav.langAr}
      </button>
      <button
        type="button"
        className={`dn-lang-btn${locale === "fr" ? " is-active" : ""}`}
        aria-pressed={locale === "fr"}
        onClick={() => setLocale("fr")}
      >
        {t.nav.langFr}
      </button>
    </div>
  );
}
